import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import HelloModal from 'common/components/hello-modal';

type Props = {
  isOpen: boolean,
  close: () => void;
};

const messages = defineMessages({
  ok: {
    id: '',
    description: 'button text that confirms user choice for the reuse warning modal',
    defaultMessage: 'Ok',
  },
  reuseWarningTitle: {
    id: '',
    description: 'title for the template reuse warning modal',
    defaultMessage: 'About your template',
  },
  reuseWarningContent: {
    id: '',
    description: 'body message for the template reuse warning modal',
    defaultMessage: 'The template initially used to create this request could not be reused because it has been deleted or edited since.',
  },
});

export default function ReuseWarningModal({ isOpen, close }: Props) {
  const intl = useIntl();

  return (
    <HelloModal
      isOpen={isOpen}
      contentLabel={intl.formatMessage(messages.reuseWarningTitle)}
      showCloseIcon={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onRequestClose={close}
      buttons={[
        {
          type: 'primary',
          'data-qa-ref': 'submit-me-now-signer-confirm',
          text: intl.formatMessage(messages.ok),
          onClick: close,
        },
      ]}
    >
      {intl.formatMessage(messages.reuseWarningContent)}
    </HelloModal>
  );
}
